export default __webpack_public_path__ + "static/media/exit-load-icon.bfb95552.svg";